export const blocDConstants = {
  GET_BLOCD_REQUEST: 'GET_BLOCD_REQUEST',
  GET_BLOCD_SUCCESS: 'GET_BLOCD_SUCCESS',
  GET_BLOCD_FAILURE: 'GET_BLOCD_FAILURE',

  UPDATE_BLOCD_REQUEST: 'UPDATE_BLOCD_REQUEST',
  UPDATE_BLOCD_SUCCESS: 'UPDATE_BLOCD_SUCCESS',
  UPDATE_BLOCD_FAILURE: 'UPDATE_BLOCD_FAILURE',
};
